class DadosVinculacaoHorariosHorasAtividades {
  constructor(horario, horariosDiaDaSemana) {
    this.horario = horario ? horario : null;
    this.horariosDiaDaSemana = horariosDiaDaSemana ? horariosDiaDaSemana : null;
  }
}
export default DadosVinculacaoHorariosHorasAtividades;
